import * as actionTypes from "./actionTypes";

export const actions = {
  showPayNowModal: () => ({
    type: actionTypes.SHOW_PAY_NOW_MODAL,
  }),
  hidePayModal: () => ({
    type: actionTypes.HIDE_PAY_NOW_MODAL,
  }),
  showPayModalSuccess: () => ({
    type: actionTypes.SHOW_PAY_NOW_SUCCESS,
  }),
};

const initialState = {
  show: false,
  success: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SHOW_PAY_NOW_MODAL: {
      return Object.assign(state, {
        show: true,
      });
    }

    case actionTypes.HIDE_PAY_NOW_MODAL: {
      return Object.assign(state, {
        show: false,
        success: false,
      });
    }

    case actionTypes.SHOW_PAY_NOW_SUCCESS: {
      return Object.assign(state, {
        show: false,
        success: true,
      });
    }

    default: {
      return initialState;
    }
  }
};
reducer.initialState = initialState;
export default reducer;
